/* eslint-disable react/button-has-type */
import React, { useState, useRef } from 'react';
import { Global, css } from '@emotion/react';

const globalStyles = css`
  .dhub * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  .dhub {
    font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
    background: #faf9f7;
    color: #1a1a1a;
    min-height: 100vh;
  }
  .dhub .app {
    max-width: 860px;
    margin: 0 auto;
    padding: 0 0 48px;
  }
  .dhub .nav {
    background: #fff;
    border-bottom: 1px solid #e8e4df;
    padding: 0 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .dhub .nav-logo {
    font-family: 'Georgia', serif;
    font-size: 17px;
    font-weight: 400;
    color: #1a1a1a;
    padding: 16px 0;
  }
  .dhub .nav-right {
    font-size: 12px;
    color: #9a9087;
  }
  .dhub .page-header {
    padding: 36px 32px 0;
  }
  .dhub .page-eyebrow {
    font-size: 10px;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #9a9087;
    margin-bottom: 10px;
  }
  .dhub .page-title {
    font-family: 'Georgia', serif;
    font-size: 28px;
    font-weight: 400;
    color: #1a1a1a;
    margin-bottom: 8px;
    letter-spacing: -0.01em;
  }
  .dhub .page-sub {
    font-size: 13px;
    color: #9a9087;
    line-height: 1.6;
    max-width: 520px;
    margin-bottom: 28px;
  }
  .dhub .tabs {
    display: flex;
    border-bottom: 1px solid #e8e4df;
    padding: 0 32px;
    margin-bottom: 32px;
  }
  .dhub .tab {
    font-size: 13px;
    padding: 10px 18px 14px;
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    color: #9a9087;
    margin-bottom: -1px;
    font-family: inherit;
  }
  .dhub .tab.active {
    color: #1a1a1a;
    border-bottom-color: #1a1a1a;
  }
  .dhub .tab:hover:not(.active) {
    color: #1a1a1a;
  }
  .dhub .progress-section {
    padding: 0 32px;
    margin-bottom: 28px;
  }
  .dhub .progress-top {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 8px;
  }
  .dhub .progress-label {
    font-size: 12px;
    color: #1a1a1a;
    font-weight: 500;
  }
  .dhub .progress-count {
    font-size: 12px;
    color: #9a9087;
  }
  .dhub .progress-track {
    height: 5px;
    background: #e8e4df;
    border-radius: 3px;
    overflow: hidden;
  }
  .dhub .progress-fill {
    height: 5px;
    background: #1a1a1a;
    border-radius: 3px;
    transition: width 0.4s;
  }
  .dhub .req-list {
    padding: 0 32px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .dhub .req-card {
    background: #fff;
    border: 1px solid #e0dbd4;
    border-radius: 12px;
    padding: 18px 20px;
    display: flex;
    align-items: flex-start;
    gap: 16px;
    transition: border-color 0.15s;
  }
  .dhub .req-card:hover {
    border-color: #c5bfb8;
  }
  .dhub .req-card.done {
    border-left: 3px solid #6b9e5e;
  }
  .dhub .req-card.pending {
    border-left: 3px solid #e8a838;
  }
  .dhub .req-card.not-required {
    border-left: 3px solid #e0dbd4;
    opacity: 0.7;
  }
  .dhub .req-icon {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1px;
  }
  .dhub .icon-done {
    background: #e8f2e5;
  }
  .dhub .icon-pending {
    background: #fff8ec;
  }
  .dhub .icon-not-required {
    background: #f3f0eb;
  }
  .dhub .check {
    width: 14px;
    height: 10px;
    border-left: 2px solid #6b9e5e;
    border-bottom: 2px solid #6b9e5e;
    transform: rotate(-45deg) translate(1px, -1px);
  }
  .dhub .clock {
    width: 14px;
    height: 14px;
    border: 2px solid #e8a838;
    border-radius: 50%;
    position: relative;
  }
  .dhub .clock::after {
    content: '';
    position: absolute;
    top: 1px;
    left: 5px;
    width: 2px;
    height: 5px;
    background: #e8a838;
  }
  .dhub .minus {
    width: 10px;
    height: 2px;
    background: #9a9087;
    border-radius: 1px;
  }
  .dhub .req-content {
    flex: 1;
    min-width: 0;
  }
  .dhub .req-title {
    font-size: 14px;
    font-weight: 500;
    color: #1a1a1a;
    margin-bottom: 4px;
  }
  .dhub .req-desc {
    font-size: 12px;
    color: #9a9087;
    line-height: 1.5;
    margin-bottom: 10px;
  }
  .dhub .req-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .dhub .req-pill {
    font-size: 10px;
    padding: 3px 10px;
    border-radius: 20px;
    letter-spacing: 0.02em;
  }
  .dhub .pill-done {
    background: #e8f2e5;
    color: #4a7a3e;
  }
  .dhub .pill-pending {
    background: #fff8ec;
    color: #a06000;
  }
  .dhub .pill-not-required {
    background: #f3f0eb;
    color: #9a9087;
  }
  .dhub .req-cta {
    font-size: 12px;
    padding: 7px 18px;
    border-radius: 100px;
    cursor: pointer;
    transition: all 0.15s;
    font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
  }
  .dhub .req-cta.ghost {
    background: none;
    border: 1.5px solid #e0dbd4;
    color: #1a1a1a;
  }
  .dhub .req-cta.ghost:hover {
    border-color: #1a1a1a;
  }
  .dhub .req-cta.primary {
    background: #1a1a1a;
    border: 1.5px solid #1a1a1a;
    color: #faf9f7;
  }
  .dhub .req-cta.primary:hover {
    background: #333;
  }
  .dhub .req-cta:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .dhub .summary {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    padding: 0 32px;
    margin-bottom: 28px;
  }
  .dhub .sum-card {
    background: #fff;
    border: 1px solid #e0dbd4;
    border-radius: 10px;
    padding: 14px 16px;
    text-align: center;
  }
  .dhub .sum-val {
    font-family: 'Georgia', serif;
    font-size: 24px;
    font-weight: 400;
    color: #1a1a1a;
    margin-bottom: 3px;
  }
  .dhub .sum-lbl {
    font-size: 11px;
    color: #9a9087;
    letter-spacing: 0.03em;
  }
  .dhub-toast {
    position: fixed;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    background: #1a1a1a;
    color: #faf9f7;
    font-size: 12px;
    padding: 10px 20px;
    border-radius: 8px;
    opacity: 0;
    transition: opacity 0.3s;
    pointer-events: none;
    z-index: 99;
    font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif;
  }
  .dhub-toast.show {
    opacity: 1;
  }
  .dhub .placeholder-tab {
    padding: 48px 32px;
    text-align: center;
    color: #9a9087;
    font-size: 13px;
  }
`;

type Status = 'done' | 'pending' | 'not-required';

type Req = {
  id: string;
  title: string;
  desc: string;
  status: Status;
  cta: string | null;
};

const REQS: Req[] = [
  {
    id: 'domain',
    title: 'Custom domain verification',
    desc: "Connect your own sending domain to improve inbox placement and build trust with your subscribers' email providers.",
    status: 'done',
    cta: 'View setup',
  },
  {
    id: 'postmaster',
    title: 'Google Postmaster integration',
    desc: 'Link Google Postmaster Tools so we can monitor your domain reputation and alert you before issues affect your Gmail delivery.',
    status: 'pending',
    cta: 'Connect now',
  },
  {
    id: 'optin',
    title: 'Enable double opt-in for forms',
    desc: 'Ask new subscribers to confirm their email before joining your list. This keeps your list healthy and your open rates high.',
    status: 'pending',
    cta: 'Go to forms',
  },
  {
    id: 'segments',
    title: 'Create smart segments',
    desc: 'Organise your audience by engagement so you can send to the right people at the right time — and protect your sending reputation.',
    status: 'done',
    cta: 'View segments',
  },
  {
    id: 'unengaged',
    title: 'Remove or archive unengaged subscribers',
    desc: "Sending to inactive contacts hurts your deliverability. We'll help you identify and clean them up in just a few steps.",
    status: 'pending',
    cta: 'Clean my list',
  },
  {
    id: 'kyc',
    title: 'Identity verification (KYC)',
    desc: 'Verify your identity to unlock higher sending volumes and keep your account in good standing with email providers.',
    status: 'not-required',
    cta: null,
  },
];

function ReqIcon({ status }: { status: Status }) {
  if (status === 'done')
    return (
      <div className="req-icon icon-done">
        <div className="check" />
      </div>
    );
  if (status === 'pending')
    return (
      <div className="req-icon icon-pending">
        <div className="clock" />
      </div>
    );
  return (
    <div className="req-icon icon-not-required">
      <div className="minus" />
    </div>
  );
}

function ReqPill({ status }: { status: Status }) {
  if (status === 'done') return <span className="req-pill pill-done">Done</span>;
  if (status === 'pending') return <span className="req-pill pill-pending">Pending</span>;
  return <span className="req-pill pill-not-required">Not required</span>;
}

function ReqCard({ req }: { req: Req }) {
  const [loading, setLoading] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout>>();

  const handleClick = () => {
    setLoading(true);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setLoading(false), 1800);
  };

  const ctaClass = req.status === 'done' ? 'ghost' : 'primary';

  return (
    <div className={`req-card ${req.status}`}>
      <ReqIcon status={req.status} />
      <div className="req-content">
        <div className="req-title">{req.title}</div>
        <div className="req-desc">{req.desc}</div>
        <div className="req-footer">
          <ReqPill status={req.status} />
          {req.cta && req.status !== 'not-required' && (
            <button className={`req-cta ${ctaClass}`} onClick={handleClick} disabled={loading}>
              {loading ? 'Redirecting…' : req.cta}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

type TabId = 'setup' | 'reputation' | 'guides';

export default function DeliverabilityHub() {
  const [activeTab, setActiveTab] = useState<TabId>('setup');

  const done = REQS.filter(r => r.status === 'done').length;
  const countable = REQS.filter(r => r.status !== 'not-required').length;
  const pending = REQS.filter(r => r.status === 'pending').length;
  const notRequired = REQS.filter(r => r.status === 'not-required').length;
  const pct = Math.round((done / countable) * 100);

  return (
    <div className="dhub">
      <Global styles={globalStyles} />
      <div className="app">
        <div className="nav">
          <div className="nav-logo">flodesk</div>
          <div className="nav-right">Hi, Sarah ↓</div>
        </div>

        <div className="page-header">
          <div className="page-eyebrow">Account health</div>
          <div className="page-title">Deliverability hub</div>
          <div className="page-sub">
            Here&apos;s everything you need to set up your account for great inbox placement.
            Complete each step to make sure your emails land where they should.
          </div>
        </div>

        <div className="tabs">
          <button
            className={`tab${activeTab === 'setup' ? ' active' : ''}`}
            onClick={() => setActiveTab('setup')}
          >
            Sender setup requirements
          </button>
          <button
            className={`tab${activeTab === 'reputation' ? ' active' : ''}`}
            onClick={() => setActiveTab('reputation')}
          >
            Sending reputation
          </button>
          <button
            className={`tab${activeTab === 'guides' ? ' active' : ''}`}
            onClick={() => setActiveTab('guides')}
          >
            Guides &amp; resources
          </button>
        </div>

        {activeTab === 'setup' && (
          <>
            <div className="summary">
              <div className="sum-card">
                <div className="sum-val" style={{ color: '#4a7a3e' }}>
                  {done}
                </div>
                <div className="sum-lbl">Completed</div>
              </div>
              <div className="sum-card">
                <div className="sum-val" style={{ color: '#a06000' }}>
                  {pending}
                </div>
                <div className="sum-lbl">Pending</div>
              </div>
              <div className="sum-card">
                <div className="sum-val" style={{ color: '#9a9087' }}>
                  {notRequired}
                </div>
                <div className="sum-lbl">Not required</div>
              </div>
            </div>

            <div className="progress-section">
              <div className="progress-top">
                <span className="progress-label">Setup progress</span>
                <span className="progress-count">
                  {done} of {countable} completed
                </span>
              </div>
              <div className="progress-track">
                <div className="progress-fill" style={{ width: `${pct}%` }} />
              </div>
            </div>

            <div className="req-list">
              {REQS.map(r => (
                <ReqCard key={r.id} req={r} />
              ))}
            </div>
          </>
        )}

        {activeTab === 'reputation' && (
          <div className="placeholder-tab">Sending reputation — coming soon</div>
        )}

        {activeTab === 'guides' && (
          <div className="placeholder-tab">Guides &amp; resources — coming soon</div>
        )}
      </div>
    </div>
  );
}
